export default function getUserInitials(firstName, lastName) {
  let initials = '';
  if (firstName) initials += firstName[0].toUpperCase();

  if (lastName) initials += lastName[0].toUpperCase();

  return initials || 'N/A';
}
